import { useRouter } from 'next/router'

/* For using the next router inside the app folder */
export const useNextRouter = useRouter